import "../../style/scss/App.scss";

export default function ContactInfoListItem({ contactInfo, onEdit }) {
  const ci = contactInfo || {};
  const id = ci.ID ?? ci.id;

  return (
    <li key={id}>
      <button
        type="button"
        className="centered skillLink location-list-item"
        data-testid={`contact-info-list-item-${id}`}
        onClick={() => onEdit?.(id)}
      >
        <div className="ContactInfo mobilePanel">
          <span className="title">{ci.Name || "Contact"}</span>
          <span className="byline">{ci.Email || ""}</span>
          <span className="rightText">{ci.Phone || ""}</span>
        </div>
      </button>
    </li>
  );
}
